import "./nocReport.css";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getNocReport } from "../../api/searchApi";
import Spinner from "../Layouts/Spinner/spinner";
import BodyHeader from "../Layouts/BodyHeader/BodyHeader";
import ViewHeader from "../Layouts/ViewHeader/ViewHeader";

const NocReport = () => {
    let { crfId, crfName } = useParams();
    const [isSearching, setIsSearching] = useState(false);
    const [searchResults, setSearchResults] = useState(null);

    useEffect(() => {
        const doSearch = async () => {
            setIsSearching(true);
            let results = await getNocReport(crfId);
            // console.log(results);
            setSearchResults(results);
            setIsSearching(false);
        };

        doSearch();
    }, [crfId]);

    const printButtonClickHandler = useCallback(() => {
        window.print();
    }, []);

    return (
        <div className="noc-report">
            <BodyHeader pageHeader="Report Viewer" />
            <ViewHeader>
                <strong>NINDS CDE Notice of Copyright<br/>
                {crfName}</strong>
            </ViewHeader>
            {isSearching && <Spinner />}
            {searchResults &&
                <table className="noc-report-table">
                    <tbody>
                        {searchResults.map(noc => {
                            const sectionText = { __html: noc.sectionText };

                            return (
                                <tr key={noc.nocDetailsId}>
                                    <td className="item-value">{noc.itemValue}</td>
                                    <td dangerouslySetInnerHTML={sectionText}></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            }
            {searchResults && <button type="button" onClick={printButtonClickHandler}>Print Report</button>}
        </div>
    );
};

export default NocReport;